class Vector {
    constructor(x, y, z){
        this.x = x
        this.y = y
        this.z = z
    }
}

export default Vector